const {Urls} = require(BUILD_ENV == "prod" ? "./prodConstants": "./drConstants")

export {
  Urls
}
